import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

const api = axios.create({
    baseURL: `${API_URL}/api`,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Dashboard
export const getDashboardStats = () => api.get('/dashboard/stats');
export const getDashboardKPIs = () => api.get('/dashboard/kpis');

// Data Sources
export const getDataSources = () => api.get('/data-sources');
export const createDataSource = (data) => api.post('/data-sources', data);
export const uploadCSV = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/data-sources/upload-csv', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

// KPIs
export const getKPIs = () => api.get('/kpis');
export const createKPI = (data) => api.post('/kpis', data);
export const getKPITrend = (kpiId, days = 30) => api.get(`/kpis/${kpiId}/trend?days=${days}`);

// KPI Computation
export const computeKPIs = (date = null) => api.post('/compute-kpis', date ? { date } : {});

// Anomalies
export const detectAnomalies = (config = {}) => api.post('/detect-anomalies', config);
export const getAnomalies = (params = {}) => api.get('/anomalies', { params });
export const getAnomalyDetail = (id) => api.get(`/anomalies/${id}`);
export const acknowledgeAnomaly = (id) => api.post(`/anomalies/${id}/acknowledge`);

// Alerts
export const getAlerts = (unreadOnly = false) => api.get('/alerts', { params: { unread_only: unreadOnly } });
export const markAlertRead = (id) => api.post(`/alerts/${id}/read`);

// Demo Data
export const generateDemoData = (days = 90) => api.post(`/generate-demo-data?days=${days}`);
export const checkData = () => api.get('/check-data');

// Export
export const exportReport = () => api.get('/export-report');

// Health
export const healthCheck = () => api.get('/health');

export default api;
